"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _Box = _interopRequireDefault(require("../../Box"));

var _Typography = require("../../Typography");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _TableCell = _interopRequireDefault(require("./TableCell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var HeaderText = (0, _styledComponents["default"])(_Typography.Text).withConfig({
  displayName: "TableHeaderCell__HeaderText",
  componentId: "sc-79x7k5-0"
})({
  textTransform: 'uppercase'
});

var TableHeaderCell = function TableHeaderCell(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var fontSize = props.fontSize,
      color = props.color,
      tableCellProps = _objectWithoutProperties(props, ["fontSize", "color"]);

  var textProps = {
    fontSize: fontSize,
    color: color
  };
  return _react["default"].createElement(_TableCell["default"], tableCellProps, _react["default"].createElement(HeaderText, _extends({
    fontSize: 0,
    fontWeight: "bold",
    width: "100%",
    textTransform: "uppercase",
    color: "neutral.600"
  }, textProps), children));
};

TableHeaderCell.defaultProps = {
  theme: _theme["default"],
  flex: 1,
  minHeight: 32
};
var _default = TableHeaderCell;
exports["default"] = _default;